import React, { useMemo, useContext } from 'react';

// DEPENDENCIES
import clsx from 'clsx';
import toLower from 'lodash/toLower';
import { useParams } from 'react-router-dom';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints.js';

// GLOBAL FUNCTIONS
import { modalFunctions, makePath, doCallback } from 'functions.js';

// HELPERS
import { RecordContext } from 'helpers/getRecordData';

// GLOBAL COMPONENTS
import Form from 'core/form/Form';

// STYLES
import styles from './statusItem.module.scss';

// VARIABLES
const TODAY = new Date();

// MAIN COMPONENT
export default function StatusItem({
  date_created,
  status_name,
  sales_time,
  created_by,
  statusName = status_name,
  backoutDate = '',
  logId,
  backoutMinDate,
  handleBackoutDateChange
}) {
  const { recordID } = useParams();
  const { refetchRecord } = useContext(RecordContext) || {};

  const modalBackoutDate = useMemo(() => backoutDate.split(' ')?.[0], [backoutDate]);

  const status = toLower(statusName);
  const showTimeStamp = status !== 'sold' && date_created && date_created !== sales_time;

  // TODO: Move backout specific logic to parent or another component and make this component more generic
  return (
    <Form.Row>
      {status !== 'backout' ? (
        <Form.PlainText
          className={['Fallout', 'Backout'].includes(statusName) && 'text-danger'}
          label={statusName}
          value={
            <>
              {sales_time}&nbsp;
              {created_by ? `by ${created_by}` : ''}
            </>
          }
          formGroup={{
            className: clsx(showTimeStamp ? 'pb-0' : 'mb-3')
          }}
        />
      ) : (
        <Form.PlainText
          label={statusName}
          className={clsx(
            styles.title,
            ['Fallout', 'Backout'].includes(statusName) && 'text-danger'
          )}
          value={
            <>
              <label
                className={styles.description}
                onClick={() =>
                  modalFunctions.add({
                    type: 'form',
                    title: 'Select Date',
                    initialValues: {
                      backout_date: modalBackoutDate,
                      log_id: logId,
                      sales_id: recordID
                    },
                    args: {
                      method: 'PUT',
                      endpoint: makePath(ENDPOINTS.sales.backoutDate, recordID),
                      onSuccess: () => doCallback(refetchRecord),
                      successMessage: 'Backout date updated.',
                      errorMessage: 'Unable to update backout date'
                    },
                    submitButton: {
                      label: 'Save'
                    },
                    fields: [
                      <Form.Date
                        maxDate={TODAY}
                        minDate={backoutMinDate}
                        name="backout_date"
                        currentDate={modalBackoutDate}
                        value={modalBackoutDate}
                        onDateValueChange={handleBackoutDateChange}
                      />
                    ]
                  })
                }
              >
                {sales_time}
              </label>
              <label className={styles.text}>&nbsp;by {created_by}</label>
            </>
          }
          formGroup={{
            className: clsx(showTimeStamp ? 'pb-0' : 'mb-3')
          }}
        />
      )}
      {showTimeStamp ? (
        <Form.PlainText
          label=" "
          className={styles.title}
          value={<label className={clsx(styles.description, 'text-gray-600')}>{`${date_created} (Timestamp)`}</label>}
          formGroup={{
            className: 'mb-3'
          }}
        />
      ) : null}
    </Form.Row>
  );
}
